/* eslint-disable quotes, comma-dangle */
import backgroundImage from "../../assets/fondo.png";
import logo from "../../assets/logo.png";
import menuIcon from "../../assets/menu.png";

import "../../styles/HomePage.css";

function HomePage() {
  return (
    <div>
      <section className="hero fade-tab">
        <video autoPlay loop muted playsInline className="background-video">
          <source src={require("../../assets/fondo.mp4")} type="video/mp4" />
          Tu navegador no soporta video en HTML5.
        </video>

        <div className="menu-icon-div">
          <img src={menuIcon} />
        </div>
        <div className="logo-container">
          <img src={logo} className="logo fade-in" alt="Logo" />
        </div>
      </section>
    </div>
  );
}

export default HomePage;
